import { cj } from 'src/utils/classNames';
import { WithChildren, WithClassName } from 'src/utils/UtilityTypes';

interface Props extends WithClassName, WithChildren {
	title: string;
}

export default function ReferralsPageChartSection({
	title,
	className,
	children,
}: Props) {
	return (
		<div className={cj('flex flex-col gap-y-lg', className)}>
			<h2 className="typo-t2 text-text-default">{title}</h2>
			{children}
		</div>
	);
}
